import { companyInfo } from '../mockData';
import { isMobileDevice } from '../components/FloatingWhatsAppButton';

const DEFAULT_SUBJECT = 'Product Inquiry - VB Global';
const DEFAULT_BODY = "Hi VB Global,\n\nI'm interested in your products. Please share details and a quotation.\n\nName:\nCompany:\nPhone:\n";

// Mobile: opens the mail app via mailto. Desktop: opens Gmail compose instantly in a new tab.
export const buildEmailLink = (subject = DEFAULT_SUBJECT, body = DEFAULT_BODY) => {
  const to = companyInfo.email;
  const su = encodeURIComponent(subject);
  const bd = encodeURIComponent(body);
  if (isMobileDevice()) return `mailto:${to}?subject=${su}&body=${bd}`;
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(to)}&su=${su}&body=${bd}`;
};
